import { JsonUtils } from '../../utils/json.util'

export class ResponseYesNo {

    private _sim: number | undefined
    private _nao: any | undefined

    get sim(): number | undefined {
        return this._sim
    }
    set sim(value: number | undefined) {
        this._sim = value
    }
    get nao(): any | undefined {
        return this._nao
    }
    set nao(value: any | undefined) {
        this._nao = value
    }
    public fromJSON(json: any): ResponseYesNo{
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }


        if (json.sim !== undefined) {
            this.sim = json.sim
        }
        if (json.nao !== undefined) {
            this.nao = json.nao
        }

        return this
    }
    public toJSON(): any {
        return {
            sim: this.sim || undefined,
            nao: this.nao || undefined,
        }
    }
}